module.exports = __webpack_public_path__ + "img/settings_icon.0b8c1d46.webp";